import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";

const defaultTimeoutMs = 5000;

const isIOS = () =>
    ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document);

/**
 * Product images render with `loading="lazy"`, so rows below the fold are never fetched and print
 * blank on multi-page documents. Force every image to load, then open the print dialog.
 */
const printWithImagesLoaded = (timeoutMs = defaultTimeoutMs) => {
    if (typeof document === "undefined") {
        return;
    }

    document.querySelectorAll<HTMLImageElement>("img[loading='lazy']").forEach(image => {
        image.loading = "eager";
    });

    if (isIOS()) {
        openPrintDialog();
        return;
    }

    const pendingImages = Array.from(document.images).filter(image => !image.complete);
    if (pendingImages.length === 0) {
        openPrintDialog();
        return;
    }

    let hasPrinted = false;
    const print = () => {
        if (hasPrinted) {
            return;
        }
        hasPrinted = true;
        window.clearTimeout(timeoutId);
        // Let the browser reflow with the newly sized images before capturing the pages.
        window.requestAnimationFrame(() => openPrintDialog());
    };

    const timeoutId = window.setTimeout(print, timeoutMs);

    Promise.all(
        pendingImages.map(
            image =>
                new Promise<void>(resolve => {
                    image.addEventListener("load", () => resolve(), { once: true });
                    image.addEventListener("error", () => resolve(), { once: true });
                }),
        ),
    ).then(print);
};

export default printWithImagesLoaded;
